<mat-form-field [appearance]="appearance || 'legacy'" class="w-full" [floatLabel]="!label || value ? 'always' : 'auto'">
  <mat-label>{{ label }}</mat-label>
  <fb-anex
    *ngIf="prefix"
    matPrefix
    [config]="prefix"
    [control]="ngControl.control"
    [templates]="templates"
    position="start"
  ></fb-anex>
  <input
    matInput
    [type]="isPasswordVisible ? 'text' : 'password'"
    fbDisableAutocomplete
    [formControl]="ngControl.control"
    [placeholder]="placeholder"
    [required]="required"
    [fbDisableControl]="disable"
    [readonly]="readonly"
    minlength="{{ minLength }}"
    maxlength="{{ maxLength }}"
  />
  <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
    <ng-container *ngIf="suffix; else showButtons">
      <fb-anex
        matSuffix
        [config]="suffix"
        [control]="ngControl.control"
        [templates]="templates"
        position="end"
      ></fb-anex>
    </ng-container>
    <ng-template #showButtons>
      <button
        tabindex="-1"
        type="button"
        matSuffix
        mat-icon-button
        [disabled]="disabled || readonly"
        (click)="toggleShowPassword()"
      >
        <mat-icon *ngIf="isPasswordVisible" class="icon-button" [class.material-icons-outlined]="true"
          >visibility_off</mat-icon
        >
        <mat-icon *ngIf="!isPasswordVisible" class="icon-button" [class.material-icons-outlined]="true"
          >visibility</mat-icon
        >
      </button>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="passwordRequirements">
    <button
      type="button"
      matSuffix
      mat-icon-button
      matTooltip="Your password must be at least 8 characters long and include at least 1 uppercase letter, 1 number, and 1 special character."
    >
      <mat-icon class="icon-button info" [class.material-icons-outlined]="true" >info</mat-icon>
    </button>
  </ng-container>
  <ng-template #showLoader>
    <fb-loader class="position-relative loader" [size]="20" [message]="undefined" matSuffix></fb-loader>
  </ng-template>
</mat-form-field>
